import { getPopoutDocuments } from "~/utils/popoutWindowsRegistry";

// Body of the window a given chart panel currently lives in — the main window or a
// popout. Modals rendered OUTSIDE the panel (navbar "add indicator", objects sidebar)
// can't derive the host from their own DOM position: they always sit in the main
// document, so they'd open in the main window even when the target chart was popped
// out (issue #375).
//
// Call it when OPENING the modal, never during render: PrimeReact stamps the mask's
// z-index once, on show. A target that changes after the first render re-creates the
// mask in the new document WITHOUT that z-index, and the dialog ends up painted under
// the chart canvases (which sit at z-index 1).
export default function getChartHostBody(chartId) {
  if (!chartId) return null;
  const selector = `.chart-panel[data-chart-id="${CSS.escape(chartId)}"]`;
  for (const doc of [document, ...getPopoutDocuments()]) {
    if (doc.querySelector(selector)) return doc.body;
  }
  return null;
}
